import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard implements CanActivate {
  constructor(private auth: AuthService, private toastr: ToastrService) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (this.auth?.permissions?.includes('core.admin') || this.auth?.user?.access === 'ADMIN') {
      return true;
    }

    const tmp = [];

    route.data.permissions.forEach((permission: string) => {
      if (!this.auth.permissions.includes(permission)) {
        tmp.push(permission);
      }
    });

    if (tmp.length > 0) {
      this.toastr.error(
        'Anda tidak berhak mengakses halaman ' + route.data.title,
        'Tidak berhak'
      );
      return false;
    }
    return true;
  }
}
